import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from "@ionic-native/camera";

@Injectable()
export class CameraActions {

  constructor( private camera: Camera,) {

  }

  async takePhoto() {
    try {
      const options: CameraOptions = {
        quality: 50,
        targetHeight: 600,
        targetWidth: 600,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        correctOrientation: true
      };
      const result = await this.camera.getPicture(options);
      return  `data:image/jpeg;base64,${result}`;
    } catch (e) {
      console.log(e);
    }
  }

  async selectPhoto() {
    try {
      const options: CameraOptions = {
              sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
              destinationType: this.camera.DestinationType.DATA_URL,
              quality: 50,
              encodingType: this.camera.EncodingType.JPEG
            };
      const result = await this.camera.getPicture(options);
      return  `data:image/jpeg;base64,${result}`;
    } catch (e) {
      console.log(e);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/camera-actions/camera-actions.ts